"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.observableController = void 0;
const asyncFn_1 = require("../asyncFn");
const reactiveState_1 = require("../reactiveState/reactiveState");
const observableMethod_1 = require("./observableMethod");
const observableController = (controller) => {
    return class extends controller {
        constructor(...args) {
            super(...args);
            this.observeMethods();
            this.viewModel = (0, reactiveState_1.createObservable)(Object.assign(Object.assign({}, this.initialState), { resetViewModel: this.resetViewModel.bind(this) }));
        }
        observeMethods() {
            var _a;
            (_a = this[observableMethod_1.observableMethods]) === null || _a === void 0 ? void 0 : _a.forEach(propertyKey => {
                const fn = this[propertyKey];
                if (isAsync(fn)) {
                    this.observeAsyncMethod(fn);
                }
                else {
                    this.observeSyncMethod(fn);
                }
            });
        }
        observeAsyncMethod(fn) {
            const resetAsyncState = () => {
                this.viewModel[fn.name] = state => {
                    return {
                        call: state.call,
                        reset: state.reset,
                        status: asyncFn_1.AsyncStateStatus.INITIAL,
                    };
                };
            };
            this[fn.name] = ((...args) => __awaiter(this, void 0, void 0, function* () {
                const methodName = fn.name;
                assertIsAsyncMethodState(this.viewModel[methodName]);
                this.viewModel[methodName].status = asyncFn_1.AsyncStateStatus.LOADING;
                const result = (yield fn.call(this, ...args));
                // If reactive state receives a function, it executes the function and assigns the result to the property
                this.viewModel[methodName] = state => (Object.assign({ call: state.call, reset: state.reset }, (result.isSuccess
                    ? { data: result.data, status: asyncFn_1.AsyncStateStatus.SUCCESS }
                    : { error: result.error, status: asyncFn_1.AsyncStateStatus.ERROR })));
                return result;
            })).bind(this);
            this.initialState[fn.name] = {
                call: this[fn.name],
                reset: resetAsyncState,
                status: asyncFn_1.AsyncStateStatus.INITIAL,
            };
        }
        observeSyncMethod(fn) {
            const resetSyncState = () => {
                this.viewModel[fn.name] = state => {
                    return {
                        call: state.call,
                        reset: state.reset,
                    };
                };
            };
            this[fn.name] = (...args) => {
                const methodName = fn.name;
                assertIsSyncMethodState(this.viewModel[methodName]);
                const result = fn.call(this, ...args);
                this.viewModel[methodName].data = result;
                return result;
            };
            this.initialState[fn.name] = {
                call: this[fn.name],
                reset: resetSyncState,
            };
        }
        resetViewModel() {
            Object.assign(this.viewModel, Object.assign(Object.assign({}, this.initialState), { resetViewModel: () => this.resetViewModel.bind(this) }));
        }
        getViewModel() {
            return this.viewModel;
        }
    };
};
exports.observableController = observableController;
function isAsync(fn) {
    return fn.constructor.name === 'AsyncFunction';
}
function assertIsAsyncMethodState(state) {
    if (!state || typeof state !== 'object' || !('status' in state)) {
        throw new Error('Method state has been externally altered');
    }
}
function assertIsSyncMethodState(state) {
    if (!state || typeof state !== 'object') {
        throw new Error('Method state has been externally altered');
    }
}
//# sourceMappingURL=observableController.js.map